import blogScott480Avif from "@/assets/blog-scott-catalogue-480.avif";
import blogScott480Webp from "@/assets/blog-scott-catalogue-480.webp";
import blogScott800Avif from "@/assets/blog-scott-catalogue-800.avif";
import blogScott800Webp from "@/assets/blog-scott-catalogue-800.webp";
import blogScott1200Avif from "@/assets/blog-scott-catalogue-1200.avif";
import blogScott1200Webp from "@/assets/blog-scott-catalogue-1200.webp";
import blogScott1600Avif from "@/assets/blog-scott-catalogue-1600.avif";
import blogScott1600Webp from "@/assets/blog-scott-catalogue-1600.webp";
import blogWantList480Avif from "@/assets/blog-want-list-480.avif";
import blogWantList480Webp from "@/assets/blog-want-list-480.webp";
import blogWantList800Avif from "@/assets/blog-want-list-800.avif";
import blogWantList800Webp from "@/assets/blog-want-list-800.webp";
import blogWantList1200Avif from "@/assets/blog-want-list-1200.avif";
import blogWantList1200Webp from "@/assets/blog-want-list-1200.webp";
import blogWantList1600Avif from "@/assets/blog-want-list-1600.avif";
import blogWantList1600Webp from "@/assets/blog-want-list-1600.webp";
import hero480Avif from "@/assets/hero-stamps-480.avif";
import hero480Webp from "@/assets/hero-stamps-480.webp";
import hero800Avif from "@/assets/hero-stamps-800.avif";
import hero800Webp from "@/assets/hero-stamps-800.webp";
import hero1200Avif from "@/assets/hero-stamps-1200.avif";
import hero1200Webp from "@/assets/hero-stamps-1200.webp";
import hero1600Avif from "@/assets/hero-stamps-1600.avif";
import hero1600Webp from "@/assets/hero-stamps-1600.webp";

import us480Avif from "@/assets/us-stamps-jfk-480.avif";
import us480Webp from "@/assets/us-stamps-jfk-480.webp";
import us800Avif from "@/assets/us-stamps-jfk-800.avif";
import us800Webp from "@/assets/us-stamps-jfk-800.webp";

import royal320Avif from "@/assets/royal-wedding-320.avif";
import royal320Webp from "@/assets/royal-wedding-320.webp";
import royal442Avif from "@/assets/royal-wedding-442.avif";
import royal442Webp from "@/assets/royal-wedding-442.webp";

import world480Avif from "@/assets/worldwide-stamps-480.avif";
import world480Webp from "@/assets/worldwide-stamps-480.webp";
import world602Avif from "@/assets/worldwide-stamps-602.avif";
import world602Webp from "@/assets/worldwide-stamps-602.webp";

import blogAlbum480Avif from "@/assets/blog-album-480.avif";
import blogAlbum480Webp from "@/assets/blog-album-480.webp";
import blogAlbum800Avif from "@/assets/blog-album-800.avif";
import blogAlbum800Webp from "@/assets/blog-album-800.webp";
import blogAlbum1200Avif from "@/assets/blog-album-1200.avif";
import blogAlbum1200Webp from "@/assets/blog-album-1200.webp";
import blogAlbum1600Avif from "@/assets/blog-album-1600.avif";
import blogAlbum1600Webp from "@/assets/blog-album-1600.webp";

import blogFdc480Avif from "@/assets/blog-fdc-480.avif";
import blogFdc480Webp from "@/assets/blog-fdc-480.webp";
import blogFdc800Avif from "@/assets/blog-fdc-800.avif";
import blogFdc800Webp from "@/assets/blog-fdc-800.webp";
import blogFdc1200Avif from "@/assets/blog-fdc-1200.avif";
import blogFdc1200Webp from "@/assets/blog-fdc-1200.webp";
import blogFdc1600Avif from "@/assets/blog-fdc-1600.avif";
import blogFdc1600Webp from "@/assets/blog-fdc-1600.webp";

import blogMagnifier480Avif from "@/assets/blog-magnifier-480.avif";
import blogMagnifier480Webp from "@/assets/blog-magnifier-480.webp";
import blogMagnifier800Avif from "@/assets/blog-magnifier-800.avif";
import blogMagnifier800Webp from "@/assets/blog-magnifier-800.webp";
import blogMagnifier1200Avif from "@/assets/blog-magnifier-1200.avif";
import blogMagnifier1200Webp from "@/assets/blog-magnifier-1200.webp";
import blogMagnifier1600Avif from "@/assets/blog-magnifier-1600.avif";
import blogMagnifier1600Webp from "@/assets/blog-magnifier-1600.webp";

import blogSoaking480Avif from "@/assets/blog-soaking-480.avif";
import blogSoaking480Webp from "@/assets/blog-soaking-480.webp";
import blogSoaking800Avif from "@/assets/blog-soaking-800.avif";
import blogSoaking800Webp from "@/assets/blog-soaking-800.webp";
import blogSoaking1200Avif from "@/assets/blog-soaking-1200.avif";
import blogSoaking1200Webp from "@/assets/blog-soaking-1200.webp";
import blogSoaking1600Avif from "@/assets/blog-soaking-1600.avif";
import blogSoaking1600Webp from "@/assets/blog-soaking-1600.webp";

import blogPerforations480Avif from "@/assets/blog-perforations-480.avif";
import blogPerforations480Webp from "@/assets/blog-perforations-480.webp";
import blogPerforations800Avif from "@/assets/blog-perforations-800.avif";
import blogPerforations800Webp from "@/assets/blog-perforations-800.webp";
import blogPerforations1200Avif from "@/assets/blog-perforations-1200.avif";
import blogPerforations1200Webp from "@/assets/blog-perforations-1200.webp";
import blogPerforations1600Avif from "@/assets/blog-perforations-1600.avif";
import blogPerforations1600Webp from "@/assets/blog-perforations-1600.webp";

import blogHistory480Avif from "@/assets/blog-history-480.avif";
import blogHistory480Webp from "@/assets/blog-history-480.webp";
import blogHistory800Avif from "@/assets/blog-history-800.avif";
import blogHistory800Webp from "@/assets/blog-history-800.webp";
import blogHistory1200Avif from "@/assets/blog-history-1200.avif";
import blogHistory1200Webp from "@/assets/blog-history-1200.webp";
import blogHistory1600Avif from "@/assets/blog-history-1600.avif";
import blogHistory1600Webp from "@/assets/blog-history-1600.webp";

export type PictureSet = {
  avifSrcSet: string;
  webpSrcSet: string;
  src: string;
  sizes: string;
  width: number;
  height: number;
};

export const heroPicture: PictureSet = {
  avifSrcSet: `${hero480Avif} 480w, ${hero800Avif} 800w, ${hero1200Avif} 1200w, ${hero1600Avif} 1600w`,
  webpSrcSet: `${hero480Webp} 480w, ${hero800Webp} 800w, ${hero1200Webp} 1200w, ${hero1600Webp} 1600w`,
  src: hero480Webp,
  sizes: "100vw",
  width: 1600,
  height: 1200,
};

/** Desktop Lighthouse (~1350 CSS px, 1x) selects the 1600w AVIF from sizes=100vw. */
export const heroLcpPreloadHref = hero1600Avif;

/** Decorative stacked card — desktop only, ~max-w-md. */
export const heroCardPicture: PictureSet = {
  avifSrcSet: `${hero480Avif} 480w, ${hero800Avif} 800w`,
  webpSrcSet: `${hero480Webp} 480w, ${hero800Webp} 800w`,
  src: hero480Webp,
  sizes: "(min-width: 1024px) 28rem, 0px",
  width: 800,
  height: 600,
};

const collectionSizes = "(min-width: 768px) 30vw, 100vw";

export const usStampsPicture: PictureSet = {
  avifSrcSet: `${us480Avif} 480w, ${us800Avif} 800w`,
  webpSrcSet: `${us480Webp} 480w, ${us800Webp} 800w`,
  src: us480Webp,
  sizes: collectionSizes,
  width: 800,
  height: 600,
};

export const royalWeddingPicture: PictureSet = {
  avifSrcSet: `${royal320Avif} 320w, ${royal442Avif} 442w`,
  webpSrcSet: `${royal320Webp} 320w, ${royal442Webp} 442w`,
  src: royal320Webp,
  sizes: collectionSizes,
  width: 442,
  height: 332,
};

export const worldStampsPicture: PictureSet = {
  avifSrcSet: `${world480Avif} 480w, ${world602Avif} 602w`,
  webpSrcSet: `${world480Webp} 480w, ${world602Webp} 602w`,
  src: world480Webp,
  sizes: collectionSizes,
  width: 602,
  height: 452,
};

const blogCardSizes = "(min-width: 768px) 30vw, 100vw";
const blogFeaturedSizes = "(min-width: 768px) 48rem, 100vw";

const blogAlbumSrcSet = {
  avifSrcSet: `${blogAlbum480Avif} 480w, ${blogAlbum800Avif} 800w, ${blogAlbum1200Avif} 1200w, ${blogAlbum1600Avif} 1600w`,
  webpSrcSet: `${blogAlbum480Webp} 480w, ${blogAlbum800Webp} 800w, ${blogAlbum1200Webp} 1200w, ${blogAlbum1600Webp} 1600w`,
};

const blogFdcSrcSet = {
  avifSrcSet: `${blogFdc480Avif} 480w, ${blogFdc800Avif} 800w, ${blogFdc1200Avif} 1200w, ${blogFdc1600Avif} 1600w`,
  webpSrcSet: `${blogFdc480Webp} 480w, ${blogFdc800Webp} 800w, ${blogFdc1200Webp} 1200w, ${blogFdc1600Webp} 1600w`,
};

const blogMagnifierSrcSet = {
  avifSrcSet: `${blogMagnifier480Avif} 480w, ${blogMagnifier800Avif} 800w, ${blogMagnifier1200Avif} 1200w, ${blogMagnifier1600Avif} 1600w`,
  webpSrcSet: `${blogMagnifier480Webp} 480w, ${blogMagnifier800Webp} 800w, ${blogMagnifier1200Webp} 1200w, ${blogMagnifier1600Webp} 1600w`,
};

export const blogAlbumCardPicture: PictureSet = {
  ...blogAlbumSrcSet,
  src: blogAlbum800Webp,
  sizes: blogCardSizes,
  width: 1600,
  height: 900,
};

export const blogAlbumFeaturedPicture: PictureSet = {
  ...blogAlbumSrcSet,
  src: blogAlbum800Webp,
  sizes: blogFeaturedSizes,
  width: 1600,
  height: 900,
};

export const blogAlbumLcpHref = blogAlbum1200Avif;

export const blogFdcCardPicture: PictureSet = {
  ...blogFdcSrcSet,
  src: blogFdc800Webp,
  sizes: blogCardSizes,
  width: 1600,
  height: 900,
};

export const blogFdcFeaturedPicture: PictureSet = {
  ...blogFdcSrcSet,
  src: blogFdc800Webp,
  sizes: blogFeaturedSizes,
  width: 1600,
  height: 900,
};

export const blogFdcLcpHref = blogFdc1200Avif;

export const blogMagnifierCardPicture: PictureSet = {
  ...blogMagnifierSrcSet,
  src: blogMagnifier800Webp,
  sizes: blogCardSizes,
  width: 1600,
  height: 900,
};

export const blogMagnifierFeaturedPicture: PictureSet = {
  ...blogMagnifierSrcSet,
  src: blogMagnifier800Webp,
  sizes: blogFeaturedSizes,
  width: 1600,
  height: 900,
};

export const blogMagnifierLcpHref = blogMagnifier1200Avif;

function blogPicturePair(
  avif480: string,
  avif800: string,
  avif1200: string,
  avif1600: string,
  webp480: string,
  webp800: string,
  webp1200: string,
  webp1600: string,
) {
  const srcSet = {
    avifSrcSet: `${avif480} 480w, ${avif800} 800w, ${avif1200} 1200w, ${avif1600} 1600w`,
    webpSrcSet: `${webp480} 480w, ${webp800} 800w, ${webp1200} 1200w, ${webp1600} 1600w`,
  };
  const card: PictureSet = {
    ...srcSet,
    src: webp800,
    sizes: blogCardSizes,
    width: 1600,
    height: 900,
  };
  const featured: PictureSet = {
    ...srcSet,
    src: webp800,
    sizes: blogFeaturedSizes,
    width: 1600,
    height: 900,
  };
  return { card, featured, lcpHref: avif1200 };
}

const blogSoakingPictures = blogPicturePair(
  blogSoaking480Avif,
  blogSoaking800Avif,
  blogSoaking1200Avif,
  blogSoaking1600Avif,
  blogSoaking480Webp,
  blogSoaking800Webp,
  blogSoaking1200Webp,
  blogSoaking1600Webp,
);

export const blogSoakingCardPicture = blogSoakingPictures.card;
export const blogSoakingFeaturedPicture = blogSoakingPictures.featured;
export const blogSoakingLcpHref = blogSoakingPictures.lcpHref;

const blogPerforationsPictures = blogPicturePair(
  blogPerforations480Avif,
  blogPerforations800Avif,
  blogPerforations1200Avif,
  blogPerforations1600Avif,
  blogPerforations480Webp,
  blogPerforations800Webp,
  blogPerforations1200Webp,
  blogPerforations1600Webp,
);

export const blogPerforationsCardPicture = blogPerforationsPictures.card;
export const blogPerforationsFeaturedPicture = blogPerforationsPictures.featured;
export const blogPerforationsLcpHref = blogPerforationsPictures.lcpHref;

const blogHistoryPictures = blogPicturePair(
  blogHistory480Avif,
  blogHistory800Avif,
  blogHistory1200Avif,
  blogHistory1600Avif,
  blogHistory480Webp,
  blogHistory800Webp,
  blogHistory1200Webp,
  blogHistory1600Webp,
);

export const blogHistoryCardPicture = blogHistoryPictures.card;
export const blogHistoryFeaturedPicture = blogHistoryPictures.featured;
export const blogHistoryLcpHref = blogHistoryPictures.lcpHref;

const blogScottPictures = blogPicturePair(
  blogScott480Avif, blogScott800Avif, blogScott1200Avif, blogScott1600Avif,
  blogScott480Webp, blogScott800Webp, blogScott1200Webp, blogScott1600Webp,
);
export const blogScottCardPicture = blogScottPictures.card;
export const blogScottFeaturedPicture = blogScottPictures.featured;
export const blogScottLcpHref = blogScottPictures.lcpHref;

const blogWantListPictures = blogPicturePair(
  blogWantList480Avif, blogWantList800Avif, blogWantList1200Avif, blogWantList1600Avif,
  blogWantList480Webp, blogWantList800Webp, blogWantList1200Webp, blogWantList1600Webp,
);
export const blogWantListCardPicture = blogWantListPictures.card;
export const blogWantListFeaturedPicture = blogWantListPictures.featured;
export const blogWantListLcpHref = blogWantListPictures.lcpHref;
